import React, { useState } from "react";
import Confetti from "react-confetti";
import useBingoStore from "../store";

const SorteioAleatorioPage = () => {
  const { from, to, setRange } = useBingoStore();

  const [rolling, setRolling] = useState(false);
  const [result, setResult] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const [rollingNumber, setRollingNumber] = useState(null);

  const handleSortear = () => {
    // Input validation using store values
    if (!from || !to || from >= to) {
      alert("Please enter valid range!");
      return;
    }

    setRolling(true);
    setResult(null);

    // Random rolling numbers effect
    const rollingInterval = setInterval(() => {
      setRollingNumber(
        Math.floor(Math.random() * (to - from + 1) + from)
      );
    }, 100);

    const winningNumber = Math.floor(Math.random() * (to - from + 1)) + from;

    setTimeout(() => {
      clearInterval(rollingInterval);
      setRolling(false);
      setResult(winningNumber);
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 5000);
    }, 3000);
  };

  const resetSorteio = () => {
    setResult(null);
    setRolling(false);
    setRollingNumber(null);

    handleSortear();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-blue-500 to-indigo-600 text-white p-4">
      <h1 className="text-4xl font-bold mb-8">Sortear Número Aleatório</h1>
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm text-gray-900">
        {!rolling && result === null && (
          <div className="flex flex-col space-y-4">
            <div className="flex space-x-4">
              <input
                type="number"
                placeholder="De"
                value={from}
                onChange={(e) => setRange(Number(e.target.value), to)}
                className="w-full p-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
              />
              <input
                type="number"
                placeholder="Até"
                value={to}
                onChange={(e) => setRange(from, Number(e.target.value))}
                className="w-full p-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>
            <button
              onClick={handleSortear}
              className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Sortear
            </button>
          </div>
        )}

        {rolling && (
          <div className="text-center text-5xl font-bold animate-pulse">
            🎲 {rollingNumber}
          </div>
        )}

        {result !== null && !rolling && (
          <div className="text-center space-y-4">
            <h2 className="text-8xl font-extrabold animate-bounce">{result}</h2>
            {showConfetti && <Confetti />}
            <div className="flex flex-col space-y-4 mt-4">
              <button
                onClick={resetSorteio}
                className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition"
              >
                Sortear Outro Número
              </button>
              <button
                onClick={() => window.history.back()}
                className="w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 transition"
              >
                Voltar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SorteioAleatorioPage;